import { FC } from 'react'

import { Flex, PreviewCard } from '@sequencehq/core-components'

import { hasQuickbooksSettingsAction } from '../../quickbooksSyncErrorContent'
import { OpenQuickbooksSettingsAction } from '../../OpenQuickbooksSettingsAction'
import { RepushSyncErrorAction } from '../../RepushSyncErrorAction'
import { SyncErrorCreditNoteSnapshot, SyncErrorTaskInput } from '../../types'
import { useSyncErrorRepush } from '../../useSyncErrorRepush'
import { ViewRecordAction } from '../../ViewRecordAction'

const TEST_ID = 'watchtower.notification.integrationSyncError.recordCard'

export const CreditNoteRecordCard: FC<{
  taskId: string
  input: SyncErrorTaskInput
  snapshot: SyncErrorCreditNoteSnapshot
}> = ({ taskId, input, snapshot }) => {
  const repush = useSyncErrorRepush({ taskId, input })
  const hasSettingsAction = hasQuickbooksSettingsAction(input)
  const canViewCreditNote = Boolean(snapshot.creditNoteId)
  const hasActions = hasSettingsAction || canViewCreditNote || Boolean(repush)

  if (!hasActions) {
    return null
  }

  return (
    <PreviewCard
      data-testid={TEST_ID}
      showBorder
      title={snapshot.creditNoteNumber ?? 'Credit note'}
      content={
        <Flex gap="8px" flexWrap="wrap" marginTop="8px">
          {hasSettingsAction && (
            <OpenQuickbooksSettingsAction
              data-testid={`${TEST_ID}.openQuickbooksSettings`}
            />
          )}
          {repush && (
            <RepushSyncErrorAction
              repush={repush}
              data-testid={`${TEST_ID}.repush`}
            />
          )}
          {canViewCreditNote && (
            <ViewRecordAction
              to={`/credit-notes/${snapshot.creditNoteId}`}
              label="View credit note"
              data-testid={`${TEST_ID}.viewCreditNote`}
            />
          )}
        </Flex>
      }
    />
  )
}
